import { Button, Card, Divider, Form, Input, Switch, Typography } from 'antd';
import React from 'react';
import { EditBase, useDataProvider, useEditContext, useNotify } from 'react-admin';
import useGetGeneralSettings from "../../providers/useGetGeneralSettings";
import { setActiveTeamLocalStorage } from "../Common/utils";

const { Title } = Typography;


const TeamEditView = () => {
  const { record: team, loading, loaded } = useEditContext();

  const dataProvider = useDataProvider();
  const notify = useNotify()
  const [form] = Form.useForm();

  const generalSettings = useGetGeneralSettings();
  const submissionBuilderSettings = generalSettings.find(setting => setting.name == 'SubmissionBuilder');
  const isVisibleSubmissionBuilder = submissionBuilderSettings?.config?.show_submission_builder == true;
  const isSubmitAllowedSubmissionBuilder = submissionBuilderSettings?.config?.enable_submit_functionality == true;

  const serviceCreatorSettings = generalSettings.find(setting => setting.name == 'ServiceCreator');
  const isVisibleCreateServiceButton = serviceCreatorSettings?.config?.show_create_service_option;
  const isSubmitAllowedCreateServiceButton = serviceCreatorSettings?.config?.allow_service_creation == true;

  const onSubmit = (values: any) => {
    if (!team)
      return
    values['preferences'] = { ...(team.preferences || {}) };

    if (isVisibleSubmissionBuilder && isSubmitAllowedSubmissionBuilder) {
      values['preferences']['allow_submit_submission_builder'] = values['allow_submit_submission_builder'];
      delete values['allow_submit_submission_builder'];
    }
    if (isVisibleCreateServiceButton && isSubmitAllowedCreateServiceButton) {
      values['preferences']['allow_service_creation'] = values['allow_service_creation'];
      delete values['allow_service_creation'];
    }

    dataProvider.update('teams', { id: team.id, data: values, previousData: { id: team.id } })
      .then((response) => {
        setActiveTeamLocalStorage(response.data)
        notify('Team updated successfully');
      })
      .catch((error: any) => {
        if (error.status == 400) {
          for (const [key, value] of Object.entries<any>(error.body)) {
            form.setFields([
              { name: key, errors: value }
            ])
          }
        }
      })
  }

  return (
    <> {
      team &&
      <Card
        bordered={false}
        bodyStyle={{ padding: '20px' }}
        className="criclebox tablespace mb-24"
      >
        <Form
          form={form}
          labelAlign='left'
          onFinish={onSubmit}
          className="row-col"
          initialValues={team}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: false }]}
            extra="If the email notification for your service is turned on, an email will be sent to this address each time there's a change instance generated for the service"
          >
            <Input placeholder="Email" />
          </Form.Item>

          {
            isVisibleSubmissionBuilder && isSubmitAllowedSubmissionBuilder &&
            <>
              <Divider />
              <Title level={5}>Submission Builder</Title>
              <Form.Item
                valuePropName='checked'
                label={"Allow Submit"}
                initialValue={team.preferences?.allow_submit_submission_builder}
                name="allow_submit_submission_builder"
                rules={[{ required: false }]}
              >
                <Switch defaultChecked={team.preferences?.allow_submit_submission_builder} />
              </Form.Item>
            </>
          }
          {
            isVisibleCreateServiceButton && isSubmitAllowedCreateServiceButton &&
            <>
              <Divider />
              <Title level={5}>Service Creator</Title>
              <Form.Item
                valuePropName='checked'
                label={"Allow Service Creation in GUI"}
                initialValue={team.preferences?.allow_service_creation}
                name="allow_service_creation"
                rules={[{ required: false }]}
              >
                <Switch defaultChecked={team.preferences?.allow_service_creation} />
              </Form.Item>
            </>
          }
          <Form.Item>
            <Button style={{ width: "10%" }} type="primary" htmlType="submit" className="form-button">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Card>
    } </>
  )
}


const TeamEdit = (props: any) => {
  return (
    <EditBase {...props}>
      <TeamEditView />
    </EditBase>
  )
}

export default TeamEdit;